import { Component } from 'react'

import ErrorPage from './ErrorPage'

/** Shows a fallback if a child component crashes. Tries rendering again when `resetKey` changes. */
class ErrorBoundary extends Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo)
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false })
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? <ErrorPage />
    }

    return this.props.children
  }
}

export default ErrorBoundary
